import { Parser } from 'json2csv';

import { getCsvOptionsToDownload } from './conversionCsvHeaders';

export interface ConversionFile {
  fileName: string;
  fileData: string;
}

export const convertFileToCsv = (
  base64: string,
  originalFileName: string,
  conversionType: string
): ConversionFile => {
  const csvHeaders = getCsvOptionsToDownload(conversionType);
  const parserOptions = { fields: csvHeaders };
  const json2csvParser = new Parser(parserOptions);

  let fileData = base64;
  let fileName = originalFileName;

  const handleFileData = (base64Content: string) => {
    const str = Buffer.from(base64Content, 'base64').toString('utf8');
    try {
      window.atob(str);
      return Buffer.from(str, 'base64').toString('utf8');
    } catch (e) {
      return str;
    }
  };

  const extractCsvString = (fileContent: string) => {
    const csvString = handleFileData(fileContent);
    const rows = csvString.trim().split('\n');
    if (rows.length === 0) return '';

    const originalHeader = rows[0].split(',').map(h => h.replace(/"/g, '')); // remove quotes
    const dataRows = rows.slice(1);

    const jsonData = dataRows.map(row => {
      const columns = row.split(',');
      const rowObject: Record<string, string> = {};
      originalHeader.forEach((header, index) => {
        rowObject[header] = columns[index]?.replace(/"/g, '');
      });
      return rowObject;
    });

    return json2csvParser.parse(jsonData);
  };

  if (fileName.includes('.json')) {
    const jsonData = JSON.parse(handleFileData(base64));
    const csvFile = json2csvParser.parse(jsonData);
    fileData = Buffer.from(csvFile).toString('base64');
    fileName = fileName.replace('json', 'csv');
  } else if (fileName.includes('.csv')) {
    fileData = Buffer.from(extractCsvString(base64)).toString('base64');
  }

  return { fileData, fileName };
};
